// Promo credit amounts shown in marketing copy. Must be kept in sync with the
// server's PROMO_SIGNUP_CREDITS / PROMO_EMAIL_VERIFY_CREDITS env vars
// (k8s/configmap.yaml) — the server is the source of truth for the actual
// grant; these only drive display strings.
export const PROMO_CREDITS = {
  SIGNUP: 10,
  EMAIL_VERIFY: 40,
} as const;
